import React from "react";
import cx from "classnames";
import { Footer, Spinner, TestPill } from "component-library";
import { dataTestIds } from "data-testids";

import { ReactComponent as SpotlightLogo } from "component-library/assets/svg/Spotlight-Logo-white.svg";
import { useUser } from "../../context/UserContext";
import useFetchNav from "../../hooks/useFetchNav";

interface ILayoutProps {
  children: React.ReactNode;
  removePadding?: boolean;
  hideFooter?: boolean;
}

const Layout: React.FC<React.PropsWithChildren<ILayoutProps>> = ({
  children,
  removePadding,
  hideFooter,
}) => {
  const { locale } = useUser();
  const { isLoading, data } = useFetchNav(locale);

  if (isLoading || !data) {
    return <Spinner />;
  }

  return (
    <main>
      <section
        className="flex min-h-screen flex-col justify-between"
        data-testid={dataTestIds.joiningPages["Layout.layout"]}
      >
        <header className="h-[50px] bg-color-neutral-one">
          <div className="flex h-full max-w-[1140px] items-center pl-[15px]">
            <SpotlightLogo height={30} />
            <TestPill />
          </div>
        </header>
        <main
          className={cx("relative flex flex-1 flex-col text-base", {
            "pt-4": !removePadding,
          })}
        >
          {children}
        </main>
        {!hideFooter && <Footer />}
      </section>
    </main>
  );
};

export default Layout;
